import React, {useState} from "react";
import PropTypes from 'prop-types';
import {useAuth} from "../../providers/AuthProvider";
import LoadingBanner from "../../components/LoadingBanner";
import {Link, useLocation, useSearchParams} from "react-router-dom";
import ErrorBanner from "../../components/ErrorBanner";
import {useProject} from "../../providers/ClientProjectProvider";
import CardList from "../../components/CardList";
import {Empty} from "antd";
import TeamCandidateProvider, {useTeamCandidate} from "../../providers/TeamCandidateProvider";
import TeamTile from "../teams/TeamTile";
import ShortlistedTeamCandidateList from "./components/ShortlistedTeamCandidateList";
import ProjectSummary from "./components/ProjectSummary";
import ProjectDeliverablesTable from "../client-lead-tools/project-scope/ProjectDeliverablesTable";
import {useAPI} from "../../config/API";

const ViewOptions = {
    List: false,//'fa-list',
    Cards: 'fa-th-large'
}

export const SelectedTeamCandidate = (props) => {

    const {auth} = useAuth();
    const {project, isProjectUpdating} = useProject();

    const {
        team, unassignCandidate, isDisabled
    } = useTeamCandidate();

    return (
        <div className="bg-white">
            <div className="bg-wrippleOffWhite px-6 py-4 flex flex-row items-center gap-4">


                <div className="flex flex-col gap-3">
                    {!props.active && (
                        <div className="bg-success text-xs px-3 py-2 text-white uppercase">
                            Team Selected
                        </div>
                    )}
                    <p className="text-xl font-semibold">
                        {project?.assigned_team_candidate?.name}
                    </p>
                </div>

                {!props.active && (
                    <div className="ml-auto flex flex-row items-center">
                        {props.children}

                        {!project.isPendingContract() && (
                            <button type="button"
                                    disabled={isDisabled || isProjectUpdating}
                                    className="btn btn-outline-dark btn-outline-white"
                                    onClick={() => {

                                        return unassignCandidate()
                                    }}
                            >
                                Reopen Project
                            </button>
                        )}
                    </div>
                )}
            </div>

            <div className="px-3 py-4 flex flex-col items-stretch gap-5">
                <ProjectSummary biddingBrief candidate={team}/>

                <ProjectDeliverablesTable canManage={true}/>
            </div>
        </div>
    );
}
const ProjectShortlistedTeamCandidates = (props) => {

    const {project, isProjectUpdating: isDisabled} = useProject();
    const [searchParams, setSearchParams] = useSearchParams()
    const [activeView, setActiveView] = useState('List');
    const location = useLocation();

    let {onRequest, onUpdated} = props;

    const hasBeenFilled = project?.assigned_team_candidate?.id;

    const {auth} = useAuth();

    const {
        data: candidateData,
        isFetching,
        isInitialLoading: isLoading,
        isRefetching,
        error,
        refetch
    } = useAPI(['teamMatches', {
            project: project.id,
            shortlisted: 1,
            per_page: 500,
            capture_candidates_request: 1
        }], {
            enabled: !hasBeenFilled,
            select: data => {
                if (data?.teams?.length) {
                    let teams = TB.orderBy(data.teams, team => {
                        if (team.declinedPosition()) return 0;
                        if (team.isAssigned()) return 7;
                        if (team.statusIsApproved() && !team.isFixedFee()) return 6;
                        if (team.isFixedFee() && team.hasConfirmedPayout() && team.hasConfirmedScope()) return 5;
                        if (team.isFixedFee() && team.hasConfirmedScope()) return 4;
                        if (team.matchStatusIsInterested()) return 3;
                        if (team.statusIsPending()) return 2;

                        return 1;
                    },'desc')

                    return {
                        ...data, teams
                    }
                }
                return data;
            },
        }
    )

    return (
        <div className="shortlisted-candidates-card container mx-auto max-w-[1225px]">


            {hasBeenFilled ? (
                <TeamCandidateProvider team={project.assigned_team_candidate}>
                    <SelectedTeamCandidate>
                        {props.children}
                    </SelectedTeamCandidate>
                </TeamCandidateProvider>
            ) : (
                <div className={TB.mapClass("candidates-view", {
                    "empty": !isLoading && !error && candidateData && candidateData?.teams?.length === 0
                })}>

                    {/*<div className="candidate-stats">*/}

                    {/*    <div className="flex flex-col gap-3 md:flex-row">*/}
                    {/*        {TB.map(stats, (value, label) => (*/}
                    {/*            <div key={label} className="flex-1 flex flex-col items-start justify-start">*/}
                    {/*                <p className="stat-label">*/}
                    {/*                    {label}*/}
                    {/*                </p>*/}
                    {/*                <p className="stat-value">*/}
                    {/*                    {value} {label === 'EST. HOURLY RATE' && <span className="ml-1">*</span>}*/}
                    {/*                </p>*/}
                    {/*            </div>*/}
                    {/*        ))}*/}
                    {/*    </div>*/}

                    {/*    <div className="flex flex-row justify-between items-center">*/}

                    {/*        <p className="text-xs pt-2 text-light-gray6">* Per average rate for role on Wripple</p>*/}

                    {/*        */}
                    {/*    </div>*/}
                    {/*</div>*/}

                    <React.Fragment>
                        {(isFetching || (!candidateData && !error)) && (
                            <div className="flex flex-col items-stretch justify-center min-h-[100px]">
                                <LoadingBanner message="Finding Candidates"/>
                            </div>
                        )}

                        {!isFetching && !error && candidateData && (
                            candidateData?.teams?.length > 0 ? (
                                <React.Fragment>
                                    <div className="flex flex-row items-center justify-start">
                                        <p className="mb-0 mr-2">
                                            View:
                                        </p>
                                        <div className="wripple-off-white-bg flex flex-row items-stretch">
                                            {TB.map(ViewOptions, (icon, label) => (
                                                <button
                                                    key={label}
                                                    disabled={isDisabled}
                                                    onClick={() => setActiveView(label)}
                                                    className={TB.mapClass("btn btn-toggle-view", {
                                                        "active": activeView === label
                                                    })}>
                                                    {icon && <i className={`fas ${icon}`}/>}
                                                    <span>{label}</span>
                                                </button>
                                            ))}
                                        </div>
                                        <div className="ml-auto">
                                            {props.children}
                                        </div>
                                    </div>

                                    {activeView === 'Cards' ? (
                                        <div className="candidates-list card-display">
                                            <CardList
                                                className="flex-grow max-w-full py-4"
                                                fillContainer={true}
                                                minHeight={715} itemsPerRow={3}
                                                items={TB.orderBy(candidateData?.teams, 'is_assigned', 'desc')
                                                    .map((candidate, i) => {
                                                        if (!candidate.isShortlisted()) {
                                                            return null;
                                                        }
                                                        return (
                                                            <TeamCandidateProvider
                                                                key={`team-${candidate.id}`}
                                                                team={candidate}>
                                                                <TeamTile
                                                                    onRequest={onRequest}
                                                                    onUpdated={onUpdated}
                                                                    isDisabled={isDisabled || isLoading || isFetching || isRefetching}
                                                                    placeholder={isLoading || isFetching || isRefetching}/>
                                                            </TeamCandidateProvider>
                                                        );
                                                    })}
                                            />
                                        </div>
                                    ) : (

                                        <ShortlistedTeamCandidateList
                                            candidates={candidateData?.teams}
                                            onRequest={onRequest}
                                            isDisabled={isDisabled || props.isDisabled}/>
                                    )}

                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    <Empty className="bg-white py-5 m-0" image={Empty.PRESENTED_IMAGE_SIMPLE}
                                           description={(
                                               <p className="font-secondary mb-0 text-center text-[14px] leading-[160%]">
                                                   No shortlist talent selected</p>
                                           )}>


                                        <Link className="self-center btn btn-primary w-[150px] mx-auto"
                                              to={location.pathname.replace(/shortlist.*$/, `talent-pool`)}>
                                            <i className="fas m-t-[-2px] fa-plus mr-2"/>
                                            Add Talent
                                        </Link>
                                    </Empty>
                                </React.Fragment>
                            )
                        )}

                        {!isFetching && error && (
                            <div className="flex flex-col items-stretch justify-start min-h-[100px]">
                                <ErrorBanner
                                    title="Something went wrong"
                                    message="Unable to load candidates. Please try again later"
                                    onRetry={refetch}/>
                            </div>
                        )}
                    </React.Fragment>
                </div>
            )}

        </div>
    )
}

ProjectShortlistedTeamCandidates.propTypes = {
    isDisabled: PropTypes.bool,
    linkParams: PropTypes.any,
    onUpdated: PropTypes.func,
    onUpdating: PropTypes.func,
    onAssignCandidate: PropTypes.func,
    onDelete: PropTypes.func,
    onViewProposal: PropTypes.func,
    canEdit: PropTypes.bool
};
export default ProjectShortlistedTeamCandidates